import { useTranslation } from 'react-i18next';
import './languageSwitcher.scss';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'en' ? 'id' : 'en';
    i18n.changeLanguage(newLang);
  };

  return (
    <button className="language-switcher" onClick={toggleLanguage}>
      {i18n.language === 'en' ? 'ID' : 'EN'}
    </button>
  );
};

export default LanguageSwitcher;